export const TrackingSVG = (props) => (
  <svg height={34} viewBox="0 0 34 34" width={34} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      transform="translate(1 1)"
    >
      <path d="m0 32h32v-32h-32z" />
      <path d="m19.487363 12.3906644c0 1.8876339-1.5300747 3.4177086-3.4177086 3.4177086s-3.4177087-1.5300747-3.4177087-3.4177086c0-1.887634 1.5300748-3.41770868 3.4177087-3.41770868s3.4177086 1.53007468 3.4177086 3.41770868z" />
      <path d="m16.069577 24.9872736c1.8148838-2.6994946 5.5677074-8.1781992 6.3981425-10.7213583.2058675-.6307592.3211842-1.3396861.3211842-2.0579002 0-3.71103104-3.0082957-6.71855274-6.7193267-6.71855274s-6.71932668 3.0075217-6.71932668 6.71855274c0 .7182141.11531671 1.427141.32118413 2.0579002.83043505 2.5431591 4.58325875 8.0218637 6.39814255 10.7213583z" />
      <path d="m16.7823736 24.0864101c2.0664135.1253779 3.6429245.7894164 3.6429245 1.588894 0 .8892544-1.9503229 1.6097903-4.3557211 1.6097903s-4.3557211-.7205359-4.3557211-1.6097903c0-.7901903 1.539362-1.4472634 3.5701744-1.5842503" />
    </g>
  </svg>
);
